import { Group, Text, Button, Code, Stack } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { IconExternalLink } from "@tabler/icons-react";

export interface TestLinkProps {
    testUrl: string;
    mb?: number;
    copyText?: string;
    linkText?: string;
    labelOnTop?: boolean;
    justButton?: boolean;
    showShare?: boolean;
    stackButtons?: boolean;
}

export default function TestLink(
    { testUrl, mb = 0, copyText = 'Copy', linkText = 'Your Testing Link', justButton = false, showShare = true, labelOnTop = false, stackButtons = false }: TestLinkProps,
) {
    const clipboard = useClipboard({ timeout: 800 });
    if(!testUrl){
        return <div>No test url</div>
    }
    if (!testUrl.startsWith('https://')) {
        // assume it just the test id
        testUrl = `https://${location.host}/t/${testUrl}`;
    }

    if (justButton) {
        return (
            <Button onClick={(e) => {
                e.stopPropagation();
                !clipboard.copied && clipboard.copy(testUrl)
            }}>{copyText}</Button>
        )
    }

    const buttons = stackButtons ? (<Stack gap={2} align="center" justify="stretch" >
        <Button onClick={() => (!clipboard.copied) && clipboard.copy(testUrl)}>{copyText}</Button>
        {showShare && <Button component="a" href={testUrl} target="_blank" variant="light" fullWidth><IconExternalLink /></Button>}
    </Stack>) : (<Group>
        <Button onClick={() => (!clipboard.copied) && clipboard.copy(testUrl)}>{copyText}</Button>
        {showShare && <Button component="a" href={testUrl} target="_blank" variant="light"><IconExternalLink /></Button>}
    </Group>);

    if (labelOnTop) {
        return (
            <Group justify='center' mb={mb} wrap='nowrap' gap={0}>
                <Stack gap={0} align="center" justify="stretch" ta='center'>
                    <Text>{linkText}</Text>
                    <Code color='var(--mantine-primary-color-2)' px={'lg'} py={'sm'} c='black' fw={800} mx={'md'}>{testUrl}</Code>
                </Stack>
                {buttons}
            </Group>
        )
    }
    return (
        <Group justify='center' mb={mb} wrap='nowrap'>
            <Text>{linkText}</Text>
            <Code color='var(--mantine-primary-color-2)' px={'lg'} py={'sm'} c='black' fw={800} mx={'md'}>{testUrl}</Code>
            {buttons}
        </Group>
    )
}